import { Component } from '@angular/core';

@Component({
  selector: 'Teranet-UserManual',
  templateUrl: './user-manual.component.html'
})
export class UserManualComponent {
  pdfSource = "../../../assets/data/UserManual.pdf";
}
